import { FormGroup, Label } from "@xola/ui-kit";
import { FormField, SwitchField } from "common";
import { useField, useFormikContext } from "formik";
import React from "react";
import { MembershipUsageType } from "types";
import { NumberInlineValuePopover } from "@/components/Common/NumberInlineValuePopover";
import type { MembershipRestrictionsFormData } from "@/components/Product/Membership/MembershipRestrictions/MembershipRestrictions";
import { useVisibility } from "@/hooks/useVisibility";

export const MembershipUsageRestriction = () => {
    const { values, setFieldValue } = useFormikContext<MembershipRestrictionsFormData>();
    const [isLimitPopoverOpen, { toggle: toggleLimitPopover }] = useVisibility(false);

    const isEnabled = values.usageType === MembershipUsageType.LIMITED;

    const handleToggle = (enabled: boolean) => {
        if (enabled) {
            setFieldValue("usageType", MembershipUsageType.LIMITED);
            setFieldValue("usageLimit", 1);
            return;
        }

        setFieldValue("usageType", MembershipUsageType.UNLIMITED);
        setFieldValue("usageLimit", 0);
    };

    const handleLimitChange = (value: number) => {
        setFieldValue("usageLimit", value ? Number.parseInt(value.toString(), 10) : "");
    };

    return (
        <FormField name="usageLimit" label="Usage Limitation">
            <SwitchField isChecked={isEnabled} onChange={handleToggle}>
                {isEnabled ? (
                    <span className="flex flex-wrap gap-x-1" onClick={(e) => e.stopPropagation()}>
                        Limit usage to
                        <NumberInlineValuePopover
                            autoSelectOnClick
                            clearable
                            min={0}
                            isOpen={isLimitPopoverOpen}
                            value={values.usageLimit}
                            text={String(values.usageLimit || 0)}
                            onChange={handleLimitChange}
                            onOpenChange={toggleLimitPopover}
                        />
                    </span>
                ) : (
                    <span>Unlimited use (toggle on to set limit)</span>
                )}
            </SwitchField>
        </FormField>
    );
};

export const MembershipOrganizerRestriction = () => {
    const [{ value }, , { setValue }] = useField<boolean>("organizerRequired");

    return (
        <FormGroup>
            <Label>Member Restriction</Label>
            <SwitchField isChecked={value} onChange={(enabled: boolean) => setValue(enabled)}>
                <span>Holder of the pass must be present to use benefits</span>
            </SwitchField>
        </FormGroup>
    );
};
